'use client';
import type { PropsWithChildren } from 'react';
import { Paywall } from '~/app/(default-layout)/s/[storyId]/_components/paywall';
import type { StoryOverview } from '~/common/types/story-overview';
import { VStack } from '@styled-system/jsx';
import { useLocalHooks } from './use-local-hooks';

type Props = PropsWithChildren<{
  story: StoryOverview;
  isTrial: boolean;
}>;

export const PayWallContainer = ({ story, isTrial, children }: Props) => {
  const { isMobile, paywallHooks } = useLocalHooks(story);

  if (!isTrial) return children;

  return (
    <VStack width="100%" gap="0">
      {children}
      {isTrial && children && (
        <Paywall
          isMobile={isMobile}
          onClickAppLink={paywallHooks.handleAppLinkClick}
          onClickBecomeVip={paywallHooks.becomeVipClick}
        />
      )}
    </VStack>
  );
};
